import { render, staticRenderFns } from "./Spotlight.vue?vue&type=template&id=5a9b5e63"
import script from "./Spotlight.vue?vue&type=script&lang=js"
export * from "./Spotlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports